/**
 * Fond ambiant du hub : blobs flous colorés (panda/grape/sky) qui flottent
 * lentement + feuilles de bambou discrètes. 100 % décoratif (`aria-hidden`,
 * `pointer-events-none`). Les animations utilisent `motion-safe:` et le
 * kill-switch global `prefers-reduced-motion` de index.css les fige.
 * Le parent doit être `relative` (le fond remplit `inset-0`).
 */

function BambooSprig({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 128" fill="none" className={className} aria-hidden="true" focusable="false">
      {/* Tige segmentée */}
      <path d="M32 122 V8" stroke="currentColor" strokeWidth="6" strokeLinecap="round" />
      <path
        d="M25 92 h14 M25 58 h14 M25 26 h14"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      {/* Feuilles */}
      <path d="M32 74 C 14 66 4 52 6 36 C 22 40 32 54 32 74 Z" fill="currentColor" />
      <path d="M32 46 C 50 38 60 24 58 8 C 42 12 32 26 32 46 Z" fill="currentColor" />
      <path d="M32 104 C 48 98 58 88 57 74 C 43 77 33 88 32 104 Z" fill="currentColor" />
    </svg>
  );
}

export function AmbientBackdrop({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={
        'pointer-events-none absolute inset-0 select-none overflow-hidden' +
        (className ? ` ${className}` : '')
      }
    >
      {/* Blobs flous : couleurs de marque, flottement lent (durées décalées) */}
      <div
        className="absolute -left-24 top-6 h-72 w-72 rounded-full bg-panda-500/20 blur-3xl motion-safe:animate-float"
        style={{ animationDuration: '9s' }}
      />
      <div
        className="absolute -right-20 top-44 h-80 w-80 rounded-full bg-grape-500/15 blur-3xl motion-safe:animate-float"
        style={{ animationDuration: '12s', animationDelay: '1.4s' }}
      />
      <div
        className="absolute -bottom-16 left-1/3 h-64 w-64 rounded-full bg-sky-500/10 blur-3xl motion-safe:animate-float"
        style={{ animationDuration: '14s', animationDelay: '0.7s' }}
      />
      {/* Bambous discrets */}
      <BambooSprig className="absolute -left-3 bottom-4 h-40 w-auto rotate-12 text-bamboo-500/20" />
      <BambooSprig className="absolute -right-2 top-20 h-32 w-auto -rotate-[24deg] text-bamboo-500/15" />
    </div>
  );
}
